import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/403/Page";

export const PATH = "/403";

const error403: NextPage = () => (
	<>
		<NskHead title="権限エラー" />
		<Component />
	</>
);

export default error403;
